import { useHistory } from 'react-router-dom'
import Standards from './Standards'
import { PricingPageContainer } from './style'

const PricingPage = () => {
  const history = useHistory()

  return (
    <PricingPageContainer>
      <div className="hero-banner">
        <div className="cta-btn" onClick={() => history.push('/get-started')}>
          <span className="cta-title">Get started for</span>
          <span className="cta-money">$129</span>
          <p>All packages come with a 10-week full refund guarantee.</p>
        </div>
      </div>
      <Standards />
    </PricingPageContainer>
  )
}

export default PricingPage
